import React from 'react';
import { Divider, Grid } from 'semantic-ui-react';
import moment from 'moment-with-locales-es6';
import { formatPhoneNumberToInternational } from 'utils/phone';
import { getPatientHomeAddress } from 'utils/address';
import {capitalize} from 'utils/patientConverter';
import bionextLogo from '../../assets/image/logo-bionextlab.svg';
moment.locale('fr');


const styles = {
	columnTitle: {
		fontSize: '1.5em',
        fontWeight: 'bold',
        textAlign:'right',
        paddingBottom: '1.4em'
	},
    columnInfo: {
		fontSize: '1.6em',
	},
};

const PatientInfo = ({patient}
) => {
	return (
        <div style={{ width: '100%', height: '100%', margin:'5%', fontSize:'0.9em' }}>
            <>
          
                <Divider horizontal style={{ margin:'25px 0'}}>
                <img src={bionextLogo} alt="Logo de BioneXt Lab" height="120px" width='450px' />
                </Divider>
                <Grid>
					<Grid.Row columns={2}>
					<Grid.Column style={styles.columnTitle}>
							Nom de naissance :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>
                                {patient?.birth_name?.toUpperCase() || '-'}
						</Grid.Column>
						{patient?.married_name && <><Grid.Column style={styles.columnTitle}>
							Nom marital :  </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient?.married_name?.toUpperCase() || '-'}
						</Grid.Column></>}
						<Grid.Column style={styles.columnTitle}>
							Prénom : </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient?.first_name || '-'}
						</Grid.Column>
						<Grid.Column style={styles.columnTitle}>
							Date de naissance :  </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.birth_date ? moment(patient.birth_date).format('DD MMMM YYYY'): '/'}
						</Grid.Column>
						<Grid.Column style={styles.columnTitle}>
							E-mail :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.email
								? `${patient.email}${
										patient.email_comment ? ` - ${patient.email_comment}` : ''
								  }`
								: 'Non renseigné'}
						</Grid.Column>
						<Grid.Column style={styles.columnTitle}>
						Téléphone portable :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.mobile_phone
								? `${formatPhoneNumberToInternational(patient.mobile_phone)}
								${patient.mobile_phone_is_relative ? '- Proche ' : ''}
								${
										patient.mobile_phone_comment
											? ` - ${patient.mobile_phone_comment}`
											: ''
								  }`
								: 'Non renseigné'}
						</Grid.Column>

						<Grid.Column style={styles.columnTitle}>
							Téléphone fixe :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.phone
								? `${formatPhoneNumberToInternational(patient.phone)}${
										patient.phone_comment ? ` - ${patient.phone_comment}` : ''
								  }`
								: 'Non renseigné'}
						</Grid.Column>

                        <Grid.Column style={styles.columnTitle}>
							Numéro CNS :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.cns || 'Non renseigné'}
						</Grid.Column>
                        <Grid.Column style={styles.columnTitle}>
							Adresse :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{getPatientHomeAddress(patient) || 'Non renseignée'}
						</Grid.Column>
                        {/* <Grid.Column style={styles.columnTitle}> //MyLab n'envoie que l'id de la mutuelle 
							Mutuelle :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.patientInsurances && patient.patientInsurances[0]
																? `${
																		patient.patientInsurances[0]?.insurance
																			?.name ?? ''
																  } - ${
																		patient.patientInsurances[0]?.number ??
																		''
																  }`
																: 'Non renseignée'}
						</Grid.Column> */}
                        <Grid.Column style={styles.columnTitle}>
							Compte myLAB :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.mylab_is_active ? 'Activé' : 'Non activé'}
						</Grid.Column>
                        {patient.grantees && patient.grantees.length > 0 && 
                        <>
                            <Grid.Column style={styles.columnTitle}>
                            Tuteur(s) :
                            </Grid.Column>
                            <Grid.Column style={styles.columnInfo}>{patient.grantees && patient.grantees.length > 0 ? <span>{patient.grantees.map(g => `${g.grantee?.last_name?.toUpperCase() ?? g.grantee?.birth_name?.toUpperCase()} ${capitalize(g.grantee?.first_name)} ${g.relation ? `(${g.relation})` : ''}`).join(', ')}</span> :'Non renseigné'}
                            </Grid.Column> 
                        </>
                        }
					</Grid.Row>
				</Grid>
            </>
        </div>
	);
};

export default PatientInfo;